import {useEffect} from "react";
import {useNavigate, useSearchParams} from "react-router-dom";
import {selfcareLoginCheck} from "./request";
import routes from "../routes.tsx";
import Routing from "../Routing.ts";

export default function useLoginCheck() {
    const navigate = useNavigate()
    const [searchParams] = useSearchParams();

    useEffect(() => {
        selfcareLoginCheck().then(r => {
            if (r.response.logged_in) {
                navigate(getRedirectUrl(searchParams))
            }
        })
    }, [navigate, searchParams])
}

export const getRedirectUrl = (searchParams: URLSearchParams): string => {
    const redirectUrlParam: string | null = searchParams.get('redirect_url');

    if (redirectUrlParam === null) {
        return Routing.Selfcare.Index
    }

    for (let i: number = 0; i < routes.length; i++) {
        const route = routes[i];
        if (route.path === redirectUrlParam) {
            return redirectUrlParam;
        }
        if (route.children !== undefined) {
            for (let j: number = 0; j < route.children.length; j++) {
                const child = route.children[j]
                if (child.path === redirectUrlParam) {
                    return redirectUrlParam;
                }
            }
        }
    }

    return Routing.Selfcare.Index
}
